import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.0242 0.675672C9.13668 0.788189 9.19987 0.940773 9.19987 1.09987C9.19987 1.25897 9.13668 1.41156 9.0242 1.52407L4.2242 6.32407C4.11168 6.43655 3.9591 6.49974 3.8 6.49974C3.6409 6.49974 3.48832 6.43655 3.3758 6.32407L0.9758 3.92407C0.866505 3.81091 0.806029 3.65935 0.807396 3.50203C0.808763 3.34471 0.871864 3.19423 0.983109 3.08298C1.09435 2.97174 1.24484 2.90863 1.40216 2.90727C1.55948 2.9059 1.71104 2.96638 1.8242 3.07567L3.8 5.05147L8.1758 0.675672C8.28832 0.563189 8.4409 0.5 8.6 0.5C8.7591 0.5 8.91168 0.563189 9.0242 0.675672Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}